import { Combobox as ComboboxPrimitive } from '@base-ui/react/combobox';
import { Trans } from '@lingui/react/macro';

import { useComboboxContext } from '@/components/Form/pickers/primitives/combobox/ComboboxContext';
import { cn } from '@/lib/utils';

export type ComboboxEmptyProps = ComboboxPrimitive.Empty.Props;

const ComboboxEmpty = ({ className, children, ...props }: ComboboxEmptyProps) => {
  const { isLoading } = useComboboxContext();

  if (isLoading) return null;

  return (
    <ComboboxPrimitive.Empty
      data-slot="combobox-empty"
      className={cn(
        'pointer-events-none! hidden w-full items-center bg-transparent! px-3 py-2 text-sm text-gray-500 italic group-data-empty/combobox-content:flex',
        className,
      )}
      {...props}
    >
      {children ?? <Trans>No results found...</Trans>}
    </ComboboxPrimitive.Empty>
  );
};

export default ComboboxEmpty;
